import type { InputHTMLAttributes } from 'react'
import styles from './DateField.module.css'

const MON3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// "2026-08-10" → "10 Aug 2026", the way dates read everywhere else in CONTROL.
export function dateLabel(iso: string) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  return m ? `${Number(m[3])} ${MON3[Number(m[2]) - 1]} ${m[1]}` : ''
}

// A date field as the design draws it: a calendar icon, then the date written out. A real date input lies over the
// whole field, so its label, keyboard entry and change events are the browser's own; a click anywhere opens the picker.
// `className` is the field's look (the form's input class), as it was on the bare input.
export function DateField({ className = '', placeholder = 'Pick a date', value, disabled, ...input }: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'> & { value: string }) {
  const shown = value ? dateLabel(value) : ''
  return (
    <span className={`${className} ${styles.field} ${disabled ? styles.disabled : ''}`}>
      <svg className={styles.icon} width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="4.5" width="18" height="17" rx="2.5" />
        <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
      </svg>
      <span className={shown ? styles.value : styles.placeholder} aria-hidden="true">
        {shown || placeholder}
      </span>
      <input
        {...input}
        type="date"
        className={styles.native}
        value={value}
        disabled={disabled}
        onClick={(e) => {
          try {
            e.currentTarget.showPicker?.()
          } catch {
            // Not allowed here (or not supported): the field still takes typed dates.
          }
          input.onClick?.(e)
        }}
      />
    </span>
  )
}
